export default "__VITE_ASSET__Dvp8srcq__"